<p-fluid>
  <p-autoComplete
    [(ngModel)]="selectedTradePartner"
    #tradePartnerSelection="ngModel"
    name="tradePartnerSelection"
    optionLabel="name"
    [suggestions]="tradePartnerSuggestions"
    (completeMethod)="onComplete($event)"
    size="30"
    emptyMessage="No Trade Partners"
    [dropdown]="true"
    [forceSelection]="forceSelection"
    [placeholder]="label"
    (onSelect)="onChange()"
    (onClear)="clearTradePartner()"
    [disabled]="disabled"
    [required]="required()"
    (onFocus)="focused.emit(null)"
    [appendTo]="appendTo"
  >
    @if (allowNameChange) {
      <ng-template #header>
        <div class="trade-partner-autocomplete-header">
          <label for="financialName" class="mb-0">Show Financial Name</label>
          <p-checkbox
            class="ml-2"
            [binary]="true"
            inputId="financialName"
            (onChange)="setDisplayNameProperty()"
            [(ngModel)]="showFinancialName"
          />
        </div>
      </ng-template>
      <ng-template let-vendor #item>
        <div class="d-flex align-items-center gap-2">
          <div>
            {{
              showFinancialName
                ? vendor.name
                : (vendor.businessAsName ?? vendor.name)
            }}
          </div>
        </div>
      </ng-template>
    }
  </p-autoComplete>
  <error-message [errorControl]="tradePartnerSelection">
    @if (tradePartnerSelection?.errors?.required && !isOneOfManyRequired()) {
      <span>Please select at least one trade partner to continue.</span>
    }
  </error-message>
</p-fluid>
